var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamsOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    display: "block",
    className: "vkuiIcon vkuiIcon--28 vkuiIcon--w-28 vkuiIcon--h-28 vkuiIcon--cards_2_outline_28",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    style: {
      width: 28,
      height: 28
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28",
    id: "cards_2_outline_28"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.008 6.498a1.013 1.013 0 0 1-.81 1.177c-1.88.34-2.576.526-3.038.878-.507.387-.88.926-1.066 1.54-.087.287-.117.65-.06 1.264.057.625.194 1.417.392 2.552l.905 5.194c.198 1.135.336 1.926.493 2.533.155.596.306.927.484 1.167.383.513.915.89 1.523 1.078.274.085.62.117 1.195.066.585-.051 1.325-.179 2.38-.367a1.003 1.003 0 0 1 1.16.823 1.013 1.013 0 0 1-.813 1.175c-1.028.183-1.862.33-2.554.39-.703.062-1.336.044-1.954-.147a5 5 0 0 1-2.537-1.798c-.401-.538-.637-1.155-.823-1.873-.18-.697-.332-1.57-.52-2.652l-.92-5.28c-.19-1.082-.341-1.955-.408-2.672-.068-.739-.055-1.4.14-2.045a5.07 5.07 0 0 1 1.776-2.568c.924-.704 2.163-.943 3.893-1.255a1.003 1.003 0 0 1 1.162.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.292 2.45.282.05c1.07.19 1.933.345 2.621.527.71.188 1.32.426 1.852.832a5.07 5.07 0 0 1 1.776 2.567c.195.645.208 1.307.14 2.045-.067.718-.219 1.59-.407 2.673l-.92 5.28c-.189 1.082-.341 1.955-.521 2.652-.186.717-.421 1.335-.822 1.873a5 5 0 0 1-2.538 1.798c-.637.197-1.29.21-2.02.14-.71-.066-1.572-.22-2.642-.41l-.282-.051c-1.07-.191-1.932-.345-2.62-.527-.71-.188-1.32-.427-1.852-.832a5.07 5.07 0 0 1-1.776-2.568c-.195-.644-.208-1.306-.14-2.044.066-.718.218-1.59.407-2.673l.92-5.28c.188-1.082.34-1.955.521-2.652.186-.718.421-1.335.822-1.873a5 5 0 0 1 2.537-1.798c.637-.197 1.291-.21 2.02-.141.71.067 1.573.22 2.642.412m-2.827 1.608c-.606-.058-.965-.027-1.249.06a3 3 0 0 0-1.522 1.08c-.178.239-.33.57-.484 1.166-.157.607-.296 1.398-.493 2.533l-.906 5.194c-.197 1.135-.334 1.927-.392 2.552-.057.613-.026.977.06 1.263a3.04 3.04 0 0 0 1.066 1.54c.237.181.564.334 1.153.49.6.16 1.382.3 2.504.5l.197.035c1.122.2 1.904.339 2.522.397.606.058.965.027 1.248-.061a3 3 0 0 0 1.523-1.079c.178-.239.33-.57.483-1.166.158-.607.296-1.398.494-2.534l.905-5.193c.198-1.136.335-1.927.393-2.552.056-.613.026-.977-.06-1.263a3.04 3.04 0 0 0-1.067-1.54c-.236-.181-.564-.335-1.152-.49-.6-.16-1.382-.3-2.504-.5l-.197-.035c-1.122-.2-1.905-.34-2.522-.397"
  }))))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cards_2_outline_28",
    style: {
      fill: "currentcolor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamsOutline);
export default __webpack_public_path__ + "static/media/streams_outline.917d758fd903563c37ea77a3f87351ff.svg";
export { ForwardRef as ReactComponent };